var _circle, _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEsPiko(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "url(#paint0_linear_494_686)",
    stroke: "#6DBE99",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 31.5,
    width: 15,
    height: 3,
    fill: "url(#paint1_linear_494_686)",
    stroke: "url(#paint2_linear_494_686)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 33.5H8V32.5H14V33.5Z",
    fill: "url(#paint3_linear_494_686)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 33.5H34V32.5H40V33.5Z",
    fill: "url(#paint4_linear_494_686)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5132 28.0936L36 27.3597L33.2498 22.7129L29.6803 28.0936H35.5132ZM26.7621 28.0936L31.8739 20.3881L29.1238 15.7413L20.9292 28.0936H26.7621ZM18.1828 28.0936L27.8288 13.5533L25.0787 8.90643L12.3499 28.0936H18.1828Z",
    fill: "url(#paint5_linear_494_686)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_494_686",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#229486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_494_686",
    x1: 16,
    y1: 32.9999,
    x2: 31.9998,
    y2: 32.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94ED89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_494_686",
    x1: 16,
    y1: 32.9999,
    x2: 31.9998,
    y2: 32.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94ED89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_494_686",
    x1: 8,
    y1: 33,
    x2: 13.9999,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94ED89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_494_686",
    x1: 34,
    y1: 33,
    x2: 39.9999,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94ED89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_494_686",
    x1: 12.3499,
    y1: 18.4993,
    x2: 35.9996,
    y2: 18.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94ED89"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsPiko);
export default __webpack_public_path__ + "static/media/esPIKO.424f0720.svg";
export { ForwardRef as ReactComponent };